import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hideText"];
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import classNames from 'classnames';
var calculateProgressNormilazed = function calculateProgressNormilazed(progressMax, progress) {
  return progress / (isNaN(progressMax) ? 1 : progressMax / 100);
};
var getDefaultProgressLineStyles = function getDefaultProgressLineStyles(_ref) {
  var progress = _ref.progress,
    progressMax = _ref.progressMax;
  return {
    width: "".concat(calculateProgressNormilazed(progressMax, progress), "%")
  };
};
var getAiProgressLineStyles = function getAiProgressLineStyles(_ref2) {
  var progressMax = _ref2.progressMax,
    progress = _ref2.progress;
  return {
    width: '100%',
    left: "-".concat(100 - calculateProgressNormilazed(progressMax, progress), "%")
  };
};
var getProgressLineStyles = function getProgressLineStyles(theme, _ref3) {
  var hideText = _ref3.hideText,
    data = _objectWithoutProperties(_ref3, _excluded);
  return theme === 'ai' ? getAiProgressLineStyles(data) : getDefaultProgressLineStyles(data);
};
var ProgressBar = function ProgressBar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(props.getClassName('control-progress-bar'), "theme-".concat(props.theme)),
    "data-aid": props.automationId,
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-line-container",
    style: {
      width: props.hideText ? '100%' : 'calc(100% - ' + (!isNaN(props.progressMax) && props.progressMax > 99 ? 51 : 39) + 'px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-line",
    style: getProgressLineStyles(props.theme, {
      progress: props.progress,
      progressMax: props.progressMax,
      hideText: props.hideText
    })
  })), !props.hideText && /*#__PURE__*/React.createElement("div", {
    "data-hook": "progress-text",
    className: "progress-text"
  }, props.progress, isNaN(props.progressMax) ? '%' : '/' + props.progressMax));
};
ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Set the progress */
  progress: PropTypes.number.isRequired,
  /** Override the max progress with a numeric progress, default is 100% */
  progressMax: PropTypes.number,
  /** Sets appereance theme */
  theme: PropTypes.oneOf(['default', 'ai']),
  /** Hide the progress text */
  hideText: PropTypes.bool
};
ProgressBar.defaultProps = {
  hideText: false,
  theme: 'default'
};
export default compose(ProgressBar);